import React, { useState, useEffect, useRef } from "react";
import { Button } from "../../BP2Components";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import FormComplete from "../../FormsV2/FormComplete";
import { useHistory } from "react-router-dom";
import ButtonModal from "../WidgetsSettings/Button/ButtonSettingsModal";
import { getFile, getFileBytes } from "../../../services/restAPI/RestApi";
import "./buttonWidgetStyle.less";
import IntlMessages from "@util/IntlMessages";
import { mobileStartActionByUrl, isDataIdFromPHP } from "@util/Scripts";
import { mobileStartFlutterActionByUrl } from "../../../util/Scripts";
import { useDispatch } from "react-redux";
import { setBackUrl } from "../../../appRedux/actions/Auth";
import { Icon_ChevronRight } from "../../BP2Components/Icons/icons";
import ButtonConfirmModal from "./ButtonEndModal";
import { getPHPCookie } from "../../../services/restAPI/RestApi";
import { FormV3InModal } from "../FormsV3/FormV3InModal/FormV3InModal";
import { setUrlTo } from "../../FormsV2/GeneralScripts";
import { isInNuxtContext } from "../../../util/redirect";

function makeRelativeIfSameDomain(url) {
   try {
      const urlObj = new URL(url, window.location.origin);

      // Only process if path starts with /boards/
      if (!urlObj.pathname.startsWith("/boards/")) {
         return url;
      }

      // Check if same domain (ignoring subdomains)
      if (isSameDomain(urlObj.hostname, window.location.hostname)) {
         return urlObj.pathname + urlObj.search + urlObj.hash;
      }

      return url;
   } catch (e) {
      return url;
   }
}

function isSameDomain(host1, host2) {
   // Exact match (handles IPs, localhost, etc.)
   if (host1 === host2) return true;

   // Local dev — always treat as same domain
   if (host2 === "localhost" || /^(\d+\.){3}\d+$/.test(host2)) {
      return true;
   }

   // If either looks like an IP, require exact match
   if (host1.includes(":") || /^\d+\.\d+\.\d+\.\d+$/.test(host1) || host2.includes(":")) {
      return false;
   }

   // Compare last 2 segments for regular domains
   const parts1 = host1.split(".");
   const parts2 = host2.split(".");
   if (parts1.length < 2 || parts2.length < 2) return false;

   return parts1.slice(-2).join(".") === parts2.slice(-2).join(".");
}

const ButtonWidget = ({ value, role, data }) => {
   const history = useHistory();
   const dispatch = useDispatch();
   const [customOpen, setCustomOpen] = useState(false);
   const [imgSrcFromFileId, setImgSrcFromFileId] = useState(null);
   const [phpToken, setPhpToken] = useState(null);
   const [isDisabled, setIsDisabled] = useState(false);

   const [isConfrimModalOpen, setIsConfirmModalOpen] = useState(false);

   const buttonRef = useRef();
   const contentContainerRef = useRef();

   useEffect(() => {
      let url = value.btnUrl;
      if (url.includes("{phpToken}")) {
         setIsDisabled(true);
         getPHPCookie().then((res) => {
            setPhpToken(res?.data);
            setIsDisabled(false);
            //https://carlsberg-admin-qa.bpower2.com/index.php/site/loginAndRedirect?t=&to=SpecialOffers/SpecialOffers/SpecialOffers
         });
      }
      if (!value.imageSourceURL && value.imageFileId) {
         getFileBytes(value.imageFileId).then((res) => {
            if (res.data.includes("<svg")) {
               const blob = new Blob([res.data], { type: "image/svg+xml" });
               setImgSrcFromFileId(URL.createObjectURL(blob));
            } else getFile(value.imageFileId).then((res) => setImgSrcFromFileId(res.data));
         });
      }
   }, []);

   const saveCallback = () => {
      setCustomOpen(false);
      value?.showEndingModal && setIsConfirmModalOpen(true);
   };

   const handleClick = (clickFromImage) => () => {
      if (
         (value?.isImageClickable === true && clickFromImage === true) ||
         clickFromImage === false
      ) {
         if (value.chosenOperation === "url") {
            let url = value.btnUrl;
            if (url?.includes("{phpToken}") && phpToken) {
               url = url.replaceAll("{phpToken}", phpToken);
            }

            url = makeRelativeIfSameDomain(url);

            if (value.openInNewTab === true) {
               window.open(url);
            } else {
               if (url.includes("http")) {
                  window.open(url, "_self");
               } else if (isInNuxtContext()) {
                  window.dispatchEvent(new CustomEvent("nuxt:navigate", { detail: { path: url } }));
               } else {
                  history.push(url);
               }
            }
         } else if (value.chosenOperation === "configId") {
            const searchParams = new URLSearchParams({
               processId: value.configId,
               ...(value?.dataId ? { dataId: value.dataId } : {}),
            });
            const targetPath = `/cases/${value.configId}?${searchParams.toString()}`;

            mobileStartActionByUrl(targetPath);
            mobileStartFlutterActionByUrl("startActionByUrl", targetPath);
            dispatch(setBackUrl(window.location.pathname));
            setUrlTo(targetPath);
         } else if (value.chosenOperation === "form") {
            setCustomOpen(true);
         }
      }
   };

   const marginSetBySettings = () => {
      switch (value.imageHorizontalPosition) {
         case "right":
            return "widget-button-margin-right";
         case "left":
            return "widget-button-margin-left";
         default:
            return "widget-button-margin-center";
      }
   };

   const { xsImageSize, smImageSize, mdImageSize, lgImageSize, xlImageSize } = value;

   const fillWidgetWithImage = value.fillWidgetWithImage || false;

   const contentBox = contentContainerRef?.current?.clientWidth;

   const imageWidth = xsImageSize !== 0 ? (xsImageSize / 100) * contentBox + "px" : "unset";
   const imageHeight = smImageSize !== 0 ? (smImageSize / 100) * contentBox + "px" : "unset";

   const computedHeight =
      contentContainerRef?.current?.children[0]?.clientHeight *
      (window?.innerWidth >= 1390 ? 1.3 : 1.6);

   return (
      <>
         {isConfrimModalOpen && value?.showEndingModal ? (
            <ButtonConfirmModal
               open={isConfrimModalOpen}
               onClose={setIsConfirmModalOpen}
               props={value}
            />
         ) : null}

         <div ref={buttonRef} className="widget-button">
            {value?.btnType === "ICON_TOP" || value?.btnType === "ICON_SIDE_ARROW" ? (
               <Widget
                  styleName="gx-m-0"
                  className={`card-button ${value?.hideWidgetBorder && "hidden-widget-background"}`}
                  bgColor={value.backgroundColourHex}
                  role={role}
                  extra={
                     (role === "OWNER" || role === "MODERATOR") && (
                        <SettingsModal
                           widgetId={value.id}
                           widgetName={value.name}
                           icon="setting"
                           deleteIcon="true"
                           children={<ButtonModal value={value} data={data} />}
                        />
                     )
                  }
                  onClick={handleClick(false)}
               >
                  <div
                     ref={contentContainerRef}
                     style={
                        fillWidgetWithImage
                           ? {
                                minHeight: `${computedHeight}px`,
                             }
                           : {}
                     }
                     className={`button-content-container ${value?.btnType}`}
                  >
                     <div
                        className={`widget-button-image widget-button-image-container_${value?.btnType}`}
                     >
                        {(value.imageSourceURL || imgSrcFromFileId) && (
                           <img
                              style={{
                                 width: imageWidth,
                                 height: imageHeight,
                              }}
                              className={
                                 (fillWidgetWithImage ? ` fillWidget-class` : "") +
                                 ` widget-button-image img_${value?.btnType} ` +
                                 marginSetBySettings()
                              }
                              src={value.imageSourceURL || imgSrcFromFileId}
                              alt="btn"
                           />
                        )}
                     </div>
                     <div
                        style={{
                           ...(fillWidgetWithImage && { padding: "1rem" }),
                        }}
                        className="button-text-container"
                     >
                        <h3 className={`button-text-container__title text_${value?.btnType}`}>
                           <IntlMessages id={value?.btnTitle} />
                        </h3>
                        <div className="button-text-container__sub-title">
                           <IntlMessages id={value?.contentKey} />
                        </div>
                     </div>
                     {value?.btnType === "ICON_SIDE_ARROW" && (
                        <div className="button-arrow">
                           <Icon_ChevronRight fill="none" stroke="#64748B" />
                        </div>
                     )}
                  </div>
                  {customOpen &&
                     (isDataIdFromPHP(value.formId) ? (
                        <SettingsModal
                           isOpen={customOpen}
                           setIsOpen={setCustomOpen}
                           className={"form-modal"}
                           initialWidth={1200}
                        >
                           <FormComplete
                              formId={value.formId}
                              dataId={value.dataId}
                              printable
                              saveCallback={saveCallback}
                              hideAttachments={true}
                           />
                        </SettingsModal>
                     ) : (
                        <FormV3InModal
                           formId={value.formId}
                           dataId={value.dataId}
                           printable
                           saveCallback={saveCallback}
                           setIsOpen={setCustomOpen}
                           isOpen={customOpen}
                        />
                     ))}
               </Widget>
            ) : (
               <Widget
                  styleName="gx-m-0"
                  bgColor={value.backgroundColourHex}
                  className={`${value?.hideWidgetBorder && "hidden-widget-background"}`}
                  role={role}
                  extra={
                     (role === "OWNER" || role === "MODERATOR") && (
                        <SettingsModal
                           widgetId={value.id}
                           widgetName={value.name}
                           icon="setting"
                           deleteIcon="true"
                           children={<ButtonModal value={value} data={data} />}
                        />
                     )
                  }
               >
                  {value.imageSourceURL || imgSrcFromFileId ? (
                     <div
                        onClick={handleClick(true)}
                        className={
                           "img-container" + (value?.isImageClickable ? " cursor-pointer" : "")
                        }
                     >
                        <img
                           width={imageWidth}
                           height={imageHeight}
                           type="primary"
                           size="large"
                           className={
                              (fillWidgetWithImage ? " fillWidget-class" : "") +
                              " widget-button-image " +
                              marginSetBySettings()
                           }
                           src={value.imageSourceURL || imgSrcFromFileId}
                           alt="btn"
                        />
                     </div>
                  ) : null}
                  <Button
                     ref={contentContainerRef}
                     onClick={handleClick(false)}
                     buttonType={value.btnColorType ? value.btnColorType : "primary"}
                     size="large"
                     disabled={isDisabled}
                     className="gx-w-100"
                  >
                     <span className="text-buttons p2">
                        <IntlMessages id={value?.btnTitle} />
                     </span>
                  </Button>

                  {customOpen &&
                     (isDataIdFromPHP(value.formId) ? (
                        <SettingsModal
                           isOpen={customOpen}
                           setIsOpen={setCustomOpen}
                           className={"form-modal"}
                           initialWidth={1200}
                        >
                           <FormComplete
                              formId={value.formId}
                              dataId={value.dataId}
                              printable
                              saveCallback={saveCallback}
                              hideAttachments={true}
                           />
                        </SettingsModal>
                     ) : (
                        <FormV3InModal
                           formId={value.formId}
                           dataId={value.dataId}
                           printable
                           saveCallback={saveCallback}
                           setIsOpen={setCustomOpen}
                           isOpen={customOpen}
                        />
                     ))}
               </Widget>
            )}
         </div>
      </>
   );
};

export default ButtonWidget;
